import { AUTH_TOKEN_KEY } from '@/constant/auth';

export const setAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const getAuthToken = (): string | null =>
  localStorage.getItem(AUTH_TOKEN_KEY);
